import { IViewModel } from './i-view-model';

export class BaseViewModel implements IViewModel {
  public Id = 0;
}
